var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.518,
    height: 15.518,
    viewBox: "0 0 15.518 15.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-circle-down",
    "data-name": "Icon awesome-arrow-circle-down",
    d: "M16.081,8.322A7.759,7.759,0,1,1,8.322.563,7.758,7.758,0,0,1,16.081,8.322Zm-4.493-.9L9.323,9.78V4.067a.749.749,0,0,0-.751-.751h-.5a.749.749,0,0,0-.751.751V9.78L5.055,7.418a.752.752,0,0,0-1.073-.013l-.341.344a.748.748,0,0,0,0,1.061L7.79,12.962a.748.748,0,0,0,1.061,0L13,8.81a.748.748,0,0,0,0-1.061l-.341-.344a.752.752,0,0,0-1.073.013Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#e56da1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRed);
export default __webpack_public_path__ + "static/media/arrow-down-red.d4f693254837511f779eaadbb89fd785.svg";
export { ForwardRef as ReactComponent };